import { Waiver } from "./Waiver/Waiver";
import { Main } from "./Main/Main";
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WaiverTable } from "./Waiver/WaiverTable";

const firebaseConfig = {
  apiKey: "AIzaSyC1hzQB1rEpP_3dwJjAVQK5ICPJc_BppsQ",
  authDomain: "uaps-app.firebaseapp.com",
  projectId: "uaps-app",
  storageBucket: "uaps-app.firebasestorage.app",
  messagingSenderId: "695236539277",
  appId: "1:695236539277:web:400a0de133afa5274443c4",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const db = getFirestore(app);

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="*" element={<Main />} />
          <Route path="/waiver" element={<Waiver />} />
          <Route path="/view" element={<WaiverTable />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
